import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaLock, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useAuth from "../customHooks/useAuth";
import "./Login.css";

function Login() {
  const navigate = useNavigate();
  const { authenticate, loading, error: hookError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [customError, setCustomError] = useState("");
  const currentYear = new Date().getFullYear();
  const whatsappMessage = encodeURIComponent(
    "Hola, tengo problemas para ingresar al sistema de gestión de inscripciones. ¿Podrían ayudarme, por favor?  Gracias."
  );
  const supportWhatsappUrl = `https://wa.me/5493571566042?text=${whatsappMessage}`;

  const handleLogin = async (event) => {
    event.preventDefault();
    setCustomError("");

    try {
      await authenticate({ email, password });
      navigate("/");
    } catch (err) {
      setCustomError("Usuario o contraseña incorrectos");
    }
  };

  const handleClear = () => {
    setEmail("");
    setPassword("");
    setCustomError("");
  };

  return (
    <main className="login-page">
      <section className="login-shell" aria-labelledby="login-title">
        <div className="login-brand">
          <span className="login-brand-mark">EC</span>
          <div>
            <p className="login-eyebrow">Gestión de inscripciones</p>
            <h1 id="login-title">Acceso al sistema</h1>
          </div>
        </div>

        <form className="login-panel" onSubmit={handleLogin}>
          <div className="login-field">
            <label htmlFor="username">Usuario</label>
            <div className="login-input-wrap">
              <FaUser aria-hidden="true" />
              <input
                id="username"
                type="text"
                autoComplete="username"
                placeholder="Ingrese su usuario"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
          </div>

          <div className="login-field">
            <label htmlFor="password">Contraseña</label>
            <div className="login-input-wrap">
              <FaLock aria-hidden="true" />
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                placeholder="Ingrese su contraseña"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
              <button
                type="button"
                className="login-icon-button"
                onClick={() => setShowPassword((currentValue) => !currentValue)}
                aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {(customError || hookError) && (
            <div className="login-error" role="alert">
              {customError || hookError}
            </div>
          )}

          <div className="login-actions">
            <button type="submit" className="login-submit" disabled={loading}>
              {loading ? "Accediendo..." : "Acceder"}
            </button>
            <button type="button" className="login-secondary" onClick={handleClear}>
              Limpiar
            </button>
          </div>

          <a
            className="login-help"
            href={supportWhatsappUrl}
            target="_blank"
            rel="noreferrer"
          >
            ¿Problemas para ingresar?
          </a>
        </form>
      </section>

      <footer className="login-footer">
        &copy; {currentYear} ECTech-Software. Todos los derechos reservados. v1.6.18052026
      </footer>
    </main>
  );
}

export default Login;
